interface CardItem {
  title: string;
  desc: string;
  tag: string;
  tagColor: string;
  img: string;
  imgAlt: string;
}

const cards: CardItem[] = [
  {
    title: '2024年度热播剧王《庆余年第三季》全集上线',
    desc: '范闲归来，京都风云再起。张若昀领衔原班人马，权谋与武侠交织，播放量突破百亿的现象级大剧。',
    tag: '热播剧集',
    tagColor: 'bg-accent-500',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20drama%20scene%20with%20a%20scholar%20in%20traditional%20robes%20standing%20in%20a%20grand%20palace%20courtyard%2C%20warm%20golden%20lighting%2C%20historical%20costume%20drama%20aesthetic%2C%20soft%20dramatic%20shadows%2C%20film%20poster%20quality%2C%20rich%20amber%20tones&width=800&height=500&seq=juzi-card-01&orientation=landscape',
    imgAlt: '庆余年第三季海报',
  },
  {
    title: '《玫瑰的故事》都市情感大剧口碑爆棚',
    desc: '刘亦菲主演，讲述当代女性成长与情感抉择，细腻刻画都市生活中的喜怒哀乐，全网热议。',
    tag: '口碑佳作',
    tagColor: 'bg-primary-500',
    img: 'https://readdy.ai/api/search-image?query=Modern%20urban%20romantic%20drama%20scene%20with%20a%20beautiful%20woman%20in%20fashionable%20outfit%20walking%20through%20a%20rose%20garden%20at%20sunset%2C%20warm%20soft%20lighting%2C%20cinematic%20composition%2C%20emotional%20atmosphere%2C%20film%20poster%20aesthetic&width=800&height=500&seq=juzi-card-02&orientation=landscape',
    imgAlt: '玫瑰的故事海报',
  },
  {
    title: '《长相思2》虐心仙侠引爆暑期档',
    desc: '杨紫、张晚意倾情演绎，三界纷争中的爱恨情仇，特效升级画面震撼，粉丝期待已久的续作。',
    tag: '仙侠巨制',
    tagColor: 'bg-secondary-600',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20scene%20with%20ethereal%20figures%20in%20flowing%20silk%20robes%20floating%20among%20clouds%2C%20magical%20glowing%20particles%2C%20mystical%20mountain%20landscape%2C%20dreamy%20atmosphere%2C%20soft%20peach%20and%20gold%20color%20tones&width=800&height=500&seq=juzi-card-03&orientation=landscape',
    imgAlt: '长相思2海报',
  },
  {
    title: '《墨雨云间》悬疑古装高能不断',
    desc: '吴谨言、王星越联手破局，层层反转的精彩剧情，古装悬疑新标杆，每一集都有意想不到的惊喜。',
    tag: '悬疑推荐',
    tagColor: 'bg-accent-500',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20palace%20interior%20with%20dramatic%20lighting%2C%20shadowy%20figures%20in%20traditional%20attire%2C%20ink%20wash%20painting%20atmosphere%2C%20rain%20falling%20outside%20paper%20windows%2C%20suspenseful%20cinematic%20mood%2C%20dark%20warm%20amber%20tones&width=800&height=500&seq=juzi-card-04&orientation=landscape',
    imgAlt: '墨雨云间海报',
  },
  {
    title: '暑期动漫盛宴·国漫新番集体上线',
    desc: '《斗破苍穹》《完美世界》《凡人修仙传》等热门国漫同步更新，精美画质点燃二次元热情。',
    tag: '国漫专区',
    tagColor: 'bg-primary-500',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20scene%20with%20a%20heroic%20character%20in%20fantasy%20armor%20standing%20on%20a%20mountain%20peak%2C%20epic%20landscape%20with%20glowing%20energy%2C%20vibrant%20colors%2C%20dynamic%20composition%2C%20modern%20donghua%20aesthetic&width=800&height=500&seq=juzi-card-05&orientation=landscape',
    imgAlt: '国漫新番海报',
  },
  {
    title: '纪录片精选·《地球脉动》系列震撼上线',
    desc: 'BBC级别自然纪录片精选合集，从深海到极地，超高清画质带你领略地球最壮丽的自然奇观。',
    tag: '高分纪录',
    tagColor: 'bg-secondary-600',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20vibrant%20coral%20reef%20underwater%20and%20tropical%20fish%2C%20crystal%20clear%20blue%20water%2C%20sunlight%20streaming%20through%20ocean%20surface%2C%20National%20Geographic%20style%20photography%2C%20rich%20natural%20colors&width=800&height=500&seq=juzi-card-06&orientation=landscape',
    imgAlt: '地球脉动纪录片海报',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full uppercase tracking-wide">
            精选推荐
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">编辑精选 · 不容错过的精彩内容</h2>
          <p className="mt-3 text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            每日精选热门影视剧集、动漫番剧与纪录片，为你推荐最值得看的内容。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <article key={card.title} className="bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/40 transition-all duration-200 cursor-pointer group">
              <div className="relative overflow-hidden h-48 md:h-52">
                <img
                  src={card.img}
                  alt={card.imgAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className={`${card.tagColor} text-background-50 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap`}>
                    {card.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  <span className="text-background-50 text-sm font-medium">
                    <i className="ri-play-circle-line mr-1"></i>立即观看
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-950 line-clamp-2 mb-2">{card.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}